import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-617.000000, -3111.000000)" fill={color} fillRule="nonzero">
                <g id="Group-6-Copy-3" transform="translate(574.000000, 3068.000000)">
                    <path d="M78.3409625,46.841018 C79.2196575,45.9623537 79.2196823,44.5377325 78.341018,43.6590375 C77.4623537,42.7803425 76.0377325,42.7803177 75.1590375,43.658982 L61,57.8175257 L46.8409625,43.658982 C45.9622675,42.7803177 44.5376463,42.7803425 43.658982,43.6590375 C42.7803177,44.5377325 42.7803425,45.9623537 43.6590375,46.841018 L57.817964,60.9994507 L43.6590375,75.1578834 C42.7803425,76.0365477 42.7803177,77.4611689 43.658982,78.3398639 C44.5376463,79.2185589 45.9622675,79.2185837 46.8409625,78.3399194 L61,64.1813757 L75.1590375,78.3399194 C76.0377325,79.2185837 77.4623537,79.2185589 78.341018,78.3398639 C79.2196823,77.4611689 79.2196575,76.0365477 78.3409625,75.1578834 L64.182036,60.9994507 L78.3409625,46.841018 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconClose extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
